"use client";

import { IconAlertWarningOutline18 } from "nucleo-ui-outline-18";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/lib/routes";
import { useEffect } from "react";

/**
 * Error boundary for workflow routes.
 * Catches runtime errors and provides recovery options.
 */
export default function WorkflowError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Log error to monitoring service
    console.error("[Workflow Error]", error);
  }, [error]);

  return (
    <div className="flex h-[calc(100vh-4rem)] w-full items-center justify-center bg-zinc-50 dark:bg-zinc-950">
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          <IconAlertWarningOutline18 className="h-8 w-8 text-red-600 dark:text-red-400" />
        </div>

        <div className="space-y-2">
          <h2 className="text-ds-text-primary text-xl font-semibold">Something went wrong</h2>
          <p className="body-sm">{error.message || "An unexpected error occurred while loading workflows."}</p>
          {error.digest && <p className="meta-xs">Error ID: {error.digest}</p>}
        </div>

        <div className="flex gap-3">
          <Button onClick={reset}>Try again</Button>
          <Button variant="white" onClick={() => (window.location.href = ROUTES.DASHBOARD)}>
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
